/* eslint-disable @typescript-eslint/member-delimiter-style */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react'

import { montserratStyle } from '../styles'
import { formatDashboardNumber } from '../utils/formatDashboardNumber'

interface HeatmapTableProps {
  data: (number | null)[][]
  columns?: string[] // Optional: column headers
  rowLabels?: { label: string; quantity: number }[] // Optional: row labels
  title?: string
  footer?: React.ReactNode
  getColor?: (value: number | null) => string
}

const defaultGetColor = (value: number | null) => {
  if (value === null) return 'transparent' // gris claro para celdas vacías
  if (value >= 80) return '#26342E' // verde muy oscuro
  if (value >= 40) return '#4A6459' // verde medio
  if (value >= 15) return '#AEEAD1' // verde claro
  return '#aeead14d' // celda transparente para valores bajos
}

const HeatmapTable: React.FC<HeatmapTableProps> = ({
  data,
  columns,
  rowLabels,
  title,
  footer,
  getColor = defaultGetColor,
}) => (
  <div className="bg-white rounded-lg shadow p-6">
    {title && (
      <div className="font-bold mb-4 text-base" style={{ ...montserratStyle }}>
        {title}
      </div>
    )}
    <div style={{ overflowX: 'auto' }}>
      <table className="min-w-full border-separate" style={{ borderSpacing: 2 }}>
        {columns && (
          <thead>
            <tr>
              {rowLabels && <th />} {/* Empty corner cell if row labels */}
              {columns.map((col, idx) => (
                <th key={idx} className="text-left text-xs text-gray-500 pl-2 pb-1">
                  {col}
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          {data.map((row, i) => (
            <tr key={i}>
              {rowLabels && (
                <td className="text-xs text-gray-500 font-semibold" style={{ width: 110 }}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <span>{rowLabels[i].label}</span>
                    <span className="text-xs text-gray-500 font-normal">
                      {formatDashboardNumber(rowLabels[i].quantity)} usuarios
                    </span>
                  </div>
                </td>
              )}
              {row.map((cell, j) => (
                <td
                  key={j}
                  style={{
                    height: 40,
                    background: getColor(cell),
                    textAlign: 'center',
                    color: cell && cell >= 80 ? '#fff' : '#222',
                    fontWeight: 500,
                  }}
                >
                  {cell !== null && cell !== undefined ? `${cell}%` : '---'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    {footer && <div className="mt-4 text-s text-gray-400">{footer}</div>}
  </div>
)

HeatmapTable.defaultProps = {
  getColor: defaultGetColor,
  columns: undefined,
  rowLabels: undefined,
  title: undefined,
  footer: undefined,
}

export default HeatmapTable
